export default {
      id: "plus-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }